import { Component, Input, Optional, Self, HostBinding } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { ComputedImage } from '@model/computed-image';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'app-image-formcontrol',
  templateUrl: './image-formcontrol.component.html',
  styleUrls: ['./image-formcontrol.component.scss'],

  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: ImageFormcontrolComponent,
    },
  ],
})
export class ImageFormcontrolComponent implements MatFormFieldControl<ComputedImage>, ControlValueAccessor {
  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  get value() {
    return this._value;
  }
  set value(v: ComputedImage) {
    this._value = v;
    this.stateChanges.next();
  }
  private _value: ComputedImage;

  public disabled: boolean = false;
  public stateChanges = new Subject<void>();

  static nextId = 0;
  @HostBinding() id = `imageformcontrol-${ImageFormcontrolComponent.nextId++}`;

  public placeholder;
  public focused;
  public empty;
  public shouldLabelFloat;

  @Input()
  get required() {
    return this._required;
  }
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }
  private _required = false;

  public errorState: boolean = false;

  @HostBinding('attr.aria-describedby') describedBy = '';
  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  public onContainerClick;

  public onChanged;
  public onTouched;

  writeValue(v: ComputedImage) {
    this.value = v;
  }
  registerOnChange(fn: any) {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
